import { render } from "./conferenceCard.vue?vue&type=template&id=8adf5f88&scoped=true"
import script from "./conferenceCard.vue?vue&type=script&lang=js"
export * from "./conferenceCard.vue?vue&type=script&lang=js"

import "./conferenceCard.vue?vue&type=style&index=0&id=8adf5f88&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adf5f88"]])

export default __exports__